// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".beda75d3081fc0f0bc2b6ddeb7968dfd.js";
};